<template>
  <div class="directory-breadcrumb"  >
    <a v-if="showDirectoriesButton && directoryView" v-on:click="setDirectoryView(false)" class="float-end btn btn-sm btn-primary"><i class="fas fa-list"></i>&nbsp;{{ $t("generic.list-all-files") }}</a>
    <a v-if="showDirectoriesButton && !directoryView" v-on:click="setDirectoryView(true)" class="float-end btn btn-sm btn-primary"><i class="fas fa-folder-open"></i>&nbsp;{{ $t("generic.list-by-folder") }}</a>
    <div  class="directory-link-container"  v-if="directoryView" >
          <a class="directory-link" v-on:click="setDirectory('')"><i class="fas fa-home"></i></a>
          <span v-for="(val, key)  in currentDirParts" :key="val" >
            / 
            <a 
            v-if="currentDirParts.length != (key+1)"            
            class="directory-link" v-on:click="setDirectoryPart(key+1)">{{val}}</a>
            <span class="directory-link" v-if="currentDirParts.length == (key+1)">{{val}}</span>
          </span> 
    </div>
    <div v-if="!directoryView" >
      <a class="directory-link" >
        <i class="fas fa-list"></i> 
      </a>
    </div>
  </div>
  <table id="extracted-file-list" class="file-list table table-striped">
        <thead v-if="loadingAll">
            <tr> 
              <td><i>{{ $t("generic.loading") }}</i></td>
            </tr>
        </thead>
        
        <tbody id="fileTbody" v-if="!loadingAll">
          <tr v-if="filteredFileList.length == 0" > 
            <td><i>{{ $t("generic.no-files") }}</i></td>
          </tr>
          <tr v-for="file in filteredFileList" :key="file.fullpath" >              
              <td  >                
                <div class="file-info float-start" v-if="directoryView"> 
                          <div v-if="file.isDirectory" 
                              v-on:click="setDirectory(file.directory? file.directory + '/' + file.filename: file.filename)" 
                              class="float-start fw-bold"
                              style="cursor:pointer">
                            <i class="fas fa-folder"></i>&nbsp;&nbsp;{{ file.filename }}
                          </div>
                          <div v-if="!file.isDirectory"  class="float-start" >
                            <i v-if="!file.isDirectory" class="far fa-file"></i>&nbsp;&nbsp;&nbsp;{{ file.filename }} 
                          </div>
                </div>
                <div v-if="!directoryView" class="file-info float-start">
                  <span class="d-none d-lg-inline">{{ file.truncName }}</span>                
                  <span class="d-inline d-lg-none">{{ file.truncNameSM }}</span>
                </div>
                
                <img style="height:20px;margin-top:7px"  :title="$t('ZIP.processing')" v-if="file.isDownloading" src="https://www.ezyzip.com/images/loader-tr.svg" alt="Saving" class="float-end saver-image" >                                
                  
                  <div v-if="!file.isDirectory && !file.isDownloading" class="btn-group float-end">
                      <a style="padding-right:5px" v-on:click="downloadFile(file)"  href="#" class="btn btn-sm btn-success"><i class="fas fa-file-download hidden-xs hidden-sm" ></i>&nbsp;{{ $t("generic.save") }}</a>
                      <a  style="padding-left:0"  href="#" class="btn btn-sm btn-success dropdown-toggle" data-bs-toggle="dropdown" data-toggle="dropdown"><span class="caret"></span></a>
                      
                      <div class="dropdown-menu bg-success" aria-labelledby="saveToDropbox">            
                          <a class="dropdown-item" v-on:click="uploadToDropbox(file)" rel="nofollow" href="#"><i class="fab fa-dropbox"></i>&nbsp;Dropbox</a>                                  
                      </div>
                  </div>
                  
                  <a rel="nofollow" v-on:click="previewFile(file)" v-if="!file.isDirectory && file.canPreview && !file.isDownloading" class="btn-download btn btn-sm btn-primary float-end hidden-xs hidden-sm"><i class="fas fa-search d-none d-md-inline "></i>&nbsp;{{ $t("generic.preview") }}</a>                
                  <a style="opacity:0.3;cursor: not-allowed" title="Cannot preview this file" rel="nofollow"  v-if="!file.isDirectory && !file.canPreview && !file.isDownloading" class="btn-preview btn btn-sm btn-primary float-end d-none d-md-inline"><i class="fas fa-search d-none d-md-inline"></i>&nbsp;{{ $t("generic.preview") }}</a>                
                  <div v-if="!file.isDirectory" style="margin-right:10px;" class=" file-info float-end">{{ file.sizeLabel}}</div>
              </td>
          </tr>           
        </tbody>
    </table>
</template>


<script>
import { checkPasswordError, gaEvent, gaException, saveFile } from '../../services/Utils'

export default {
  name: 'FileList',
  props: {
    showDirectories: Boolean,
    showDirectoriesButton: Boolean,
    fileList: Array,
    extractService: Object
  },
  data() {
    return {
          filteredFileList: [],
          directoryView: true,    
          currentDirParts: [],
          currentDir: '',
          loadingAll: false
       }
  },
  created() {
      this.filteredFileList = this.fileList;
      
      this.directoryView = this.showDirectories;
      //console.log('directory view set to ', this.directoryView);
      this.setDirectory(this.currentDir);
  },
  methods: {
      setDirectoryPart: function(index) {        
        let dir = this.currentDirParts.slice(0, index).join('/');
        this.setDirectory(dir);
      },
      setDirectoryView: function(directoryView) {        
        this.directoryView = directoryView;
        this.setDirectory('');
      },
      setDirectory: function(dir) {
        this.currentDir = dir;        
        if (this.directoryView) {
          this.currentDirParts = dir.split('/');
          let filtered = Array.from(this.fileList).filter(f => {return f.directory == dir});
          this.filteredFileList = filtered.sort((a,b) => {
            if(a.isDirectory > b.isDirectory) {return -1;}            
            return 0;
          });
        } else {   
          this.loadingAll = true;
          setTimeout(() => { 
            this.filteredFileList = Array.from(this.fileList).filter(f => {return !f.isDirectory});
            this.loadingAll = false;
          }, 100);
          
        }                                
      },      
      downloadFile: async function(file) {
        try {
          file.isDownloading = true;                              
          let blob = await this.extractService.extractFile(file.fullpath);                                      
          saveFile(blob, file.filename);
          
          file.isDownloading = false;
          gaEvent('filelist-download', window.location.pathname);
        } catch (e) {
            file.isDownloading = false;
            if (checkPasswordError(e)) {                            
              this.$emit('password-error');
              gaEvent('filelist-incorrect-password', window.location.pathname);
            } else {
              
              alert('Error saving file'); //TODO: better error handling. Create error handler component              
              console.log(e);
              gaException('filelist-downloadfile-error|'+ JSON.stringify(e.message));
            }   
        }
      },
      previewFile: async function(file) {        
          try {  
          //file.isDownloading = true;
          let blob = await this.extractService.extractFile(file.fullpath);
          //var fileURL = URL.createObjectURL(blob);
          
                  
          window.ezyzip = {filename: file.filename, blob};          
          let popup = window.open('/assets/preview/preview.html', 'preview', 'width=1100,height='+screen.height+',toolbar=0,menubar=0,location=0');
          if (!popup || popup.closed || typeof popup.closed=='undefined') { 
            //POPUP BLOCKED
            //alert('Popup blocked')
          } 
          let extension = file.filename.split('.').pop();
          gaEvent('filelist-preview-'+extension, window.location.pathname);
          
          } catch (e) {
               file.isDownloading = false;
              if (checkPasswordError(e)) {                            
                this.$emit('password-error');
                gaEvent('filelist-incorrect-password', window.location.pathname);
            } else {
                alert('Error previewing file'); //TODO: better error handling. Create error handler component             
                console.log(e);
                gaException('filelist-previewfile-error|' + JSON.stringify(e.message));
            }
          }
      },
      uploadToDropbox: async function(file) {
          file.isDownloading = true;
          try {
            await this.extractService.saveFileToDropbox(file.fullpath);
            file.isDownloading = false;  
          } catch(e) {
            file.isDownloading = false;
            if (checkPasswordError(e)) {                            
              this.$emit('password-error');
              gaEvent( 'filelist-incorrect-password', window.location.pathname);
            } else {
              alert('Error saving file'); //TODO: better error handling. Create error handler component              
              console.log(e);
              gaException( 'filelist-uploadtodropbox-error|'+ JSON.stringify(e.message)); 
            }
          }
      }
  }
}

</script>
<style scoped>
  
  
  
  
</style>